/* eslint-disable max-len */
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useGetGiftVoucherQuery } from '../../../api/queries/getGiftVoucher';
import { ApplicationStage } from '../../../api/types';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import { ReferenceApplicationProvider } from '../../shared/ApplicationDetailsPage/standard/ApplicationTab/ReferenceApplicationField';
import GiftVoucherForm from './GiftVoucherForm';

const GiftVoucherDetails = () => {
    const { id } = useParams<{ id: string }>();

    const { data, loading } = useGetGiftVoucherQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            id,
        },
    });

    const giftVoucher = useMemo(() => data?.giftVoucher, [data]);

    if (loading && !giftVoucher) {
        return <LoadingElement />;
    }

    if (!giftVoucher) {
        return <NotFoundResult />;
    }

    return (
        <ReferenceApplicationProvider
            referencePaths={{
                stages: {
                    [ApplicationStage.Mobility]: '/admin/mobilitybookings',
                },
            }}
        >
            <GiftVoucherForm voucher={giftVoucher} />
        </ReferenceApplicationProvider>
    );
};

export default GiftVoucherDetails;
